import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ChildrenDeduplicationCompareModalComponent } from '../../children-deduplication-compare-btn/children-deduplication-compare-modal/children-deduplication-compare-modal.component';
import { ViewChildrenMergeTreeComponent } from '../view-children-merge-tree.component';

@Component({
    selector: 'view-children-merge-tree-btn',
    templateUrl: './view-children-merge-tree-btn.component.html',
    styleUrl: './view-children-merge-tree-btn.component.scss'
})
export class ViewChildrenMergeTreeBtnComponent implements OnInit {
    @Input() studentId!: number;
    @Input() studentMsdNumber!: string;

    constructor(private dialog: MatDialog) {}

    ngOnInit(): void {}

    // Dialog Modal
    openDialog() {
        let payload: any = {};
        payload.studentId = this.studentId;
        payload.studentMsdNumber = this.studentMsdNumber;

        const dialogConfig = new MatDialogConfig();
        //dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '60vw';
        const dialogRef = this.dialog.open(ViewChildrenMergeTreeComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {
            if (res) {
            }
        });
    }
}
